import React, { useEffect, useState } from "react";
import { PlatformUsage, PostFieldLabel } from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import PostFieldError from "components/Posts/PostForm/PostFieldError/PostFieldError";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const YouTubePrivacy = ({
  post,
  selectedPlatform,
  platforms,
  disabled = false,
  onChange,
  errors,
  className = "",
}) => {
  //default to public because customers really aren't going to use private let's be honest
  const [selected, setSelected] = useState(
    post && post[FIELDS.YT_PRIVACY] ? post[FIELDS.YT_PRIVACY] : "public"
  );

  const categories = [
    {
      value: "public",
      label: "Public",
    },
    {
      value: "unlisted",
      label: "Unlisted",
    },
    {
      value: "private",
      label: "Private",
    },
  ];

  useEffect(() => {
    setSelected(post[FIELDS.YT_PRIVACY]);
  }, []);

  const handleCategoryChange = (item) => {
    setSelected(item);
    onChange(item);
  };

  return (
    <div className={className}>
      <div className="flex items-center mb-2">
        <PostFieldLabel className="mr-4">YouTube privacy status</PostFieldLabel>
        <PlatformUsage
          platforms={platforms}
          field={FIELDS.YT_PRIVACY}
          selectedPlatform={selectedPlatform}
        />
      </div>
      <Select
        value={selected}
        onValueChange={handleCategoryChange}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {categories.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <PostFieldError
        className="mt-4"
        fields={[FIELDS.YT_PRIVACY]}
        errors={errors}
      />
    </div>
  );
};

export default YouTubePrivacy;
